import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-community'
import { FxRateDetail } from 'api'
import {
  createGroupedActionRenderer,
  createActionsRenderer,
  dateFilterParams,
  gridOptionsBase,
  StandardGridColumnId,
  TypedValueGetterParams,
  withAllContext
} from 'view/components/datagrid'
import { dateQuickFilterTextGetter, makeNumberFormatter, makeTimestampFormatter } from 'view/shared/datagrid'
import { FxRateHelper } from 'model'
import { FxRateActionsButton } from './FxRateActionsButton'
import { Locale, Translation } from 'locale'

enum FxRateGridColumnId {
  FX_RATE_CURRENCY_PAIR = 'FX_RATE_CURRENCY_PAIR',
  FX_RATE_FX_RATE = 'FX_RATE_FX_RATE',
  FX_RATE_DATE_TIME_UPDATED = 'FX_RATE_DATE_TIME_UPDATED'
}

export const FxRateColumnDefs: (ColGroupDef | ColDef)[] = [
  {
    colId: StandardGridColumnId.CHECKBOX,
    headerName: Locale.translate(Translation.TC_EMPTY_HEADER),
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: true,
    width: 36,
    maxWidth: 36,
    pinned: 'left',
    lockPinned: true,
    enableRowGroup: false,
    lockPosition: true,
    lockVisible: true,
    filter: false,
    resizable: false,
    sortable: false
  },
  {
    colId: StandardGridColumnId.ACTIONS,
    headerName: Locale.translate(Translation.TC_EMPTY_HEADER),
    equals: () => false,
    width: 150,
    minWidth: 150,
    headerComponent: withAllContext(createGroupedActionRenderer(FxRateActionsButton)),
    cellClass: 'action-cell',
    cellRenderer: withAllContext(createActionsRenderer(FxRateActionsButton)),
    pinned: 'left',
    lockPinned: true,
    enableRowGroup: false,
    lockVisible: true,
    filter: false,
    sortable: false
  },
  {
    colId: FxRateGridColumnId.FX_RATE_CURRENCY_PAIR,
    valueGetter: (params: TypedValueGetterParams<FxRateDetail>) => params.data && FxRateHelper.getName(params.data.fxRate),
    headerName: Locale.translate(Translation.TC_CURRENCY_PAIR),
    width: 120,
    filter: 'agSetColumnFilter'
  },
  {
    colId: FxRateGridColumnId.FX_RATE_FX_RATE,
    valueGetter: (params: TypedValueGetterParams<FxRateDetail>) => params.data?.fxRate.rate,
    valueFormatter: makeNumberFormatter(),
    headerName: Locale.translate(Translation.TC_FX_RATE),
    width: 100,
    type: 'numericColumn',
    filter: 'agNumberColumnFilter',
    lockPinned: true,
    enableRowGroup: false
  },
  {
    colId: FxRateGridColumnId.FX_RATE_DATE_TIME_UPDATED,
    valueGetter: (params: TypedValueGetterParams<FxRateDetail>) => params.data?.fxRate?.lastUpdatedAt,
    headerName: Locale.translate(Translation.TC_DATE_TIME_UPDATED),
    width: 140,
    filter: 'agDateColumnFilter',
    ...dateFilterParams,
    valueFormatter: makeTimestampFormatter(),
    getQuickFilterText: dateQuickFilterTextGetter
  }
]

export const fxRateGridOptions: GridOptions<FxRateDetail> = {
  ...gridOptionsBase,
  getRowId: ({ data }) => data.fxRate.id
}
